import React, { useState } from 'react';
import { motion } from 'framer-motion';
import DestinationsMarquee from './DestinationsMarquee';

const domesticPlaces = [
  { title: 'Jaipur', image: '/d1.png' },
  { title: 'Udaipur', image: '/d2.png' },
  { title: 'Goa', image: '/d3.png' },
  { title: 'Jaisalmer', image: '/img/i21.jpg' },
  { title: 'Rajasthan', image: '/img/i18.jpg' },
  { title: 'Mumbai', image: '/img/i12.jpg' },
  { title: 'Rajkot', image: '/img/i31.jpg' },
];

const internationalPlaces = [
  { title: 'Bali', image: '/img/i33.jpg' },
  { title: 'Dubai', image: '/img/i34.jpg' },
  { title: 'Phuket', image: '/img/i35.jpg' },
  { title: 'Santorini', image: '/img/i36.jpg' },
  { title: 'Tuscany', image: '/img/i37.jpg' },
  { title: 'Paris', image: '/img/i38.jpg' },
];

// Re-export for DestinationsMarquee compatibility
export const places = [...domesticPlaces, ...internationalPlaces];

export default function Destinations() {
  const [tab, setTab] = useState<'domestic' | 'international'>('domestic');
  return (
    <section id="destinations" className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <motion.h3
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true, margin: '-100px' }}
            className="text-3xl font-serif text-black mb-4"
          >
            Destination Weddings, Elegantly Orchestrated
          </motion.h3>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true, margin: '-100px' }}
            className="text-sm text-gray-600 leading-relaxed max-w-3xl mx-auto"
          >
            Palaces, beaches, desert dunes, or urban chic — wherever you envision your vows, we tailor an experience worthy of your story.
          </motion.p>
        </div>

        {/* Tabs */}
        <div className="flex items-center justify-center gap-4 mb-10">
          <button
            className={`px-6 py-2 border text-[11px] uppercase tracking-[0.2em] rounded-sm transition-colors ${
              tab === 'domestic' ? 'bg-black text-white border-black' : 'bg-white text-black border-black'
            }`}
            onClick={() => setTab('domestic')}
          >
            Domestic
          </button>
          <button
            className={`px-6 py-2 border text-[11px] uppercase tracking-[0.2em] rounded-sm transition-colors ${
              tab === 'international' ? 'bg-black text-white border-black' : 'bg-white text-black border-black'
            }`}
            onClick={() => setTab('international')}
          >
            International
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {(tab === 'domestic' ? domesticPlaces : internationalPlaces).map((place, index) => (
            <motion.div
              key={place.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: index * 0.05 }}
              viewport={{ once: true, margin: '-100px' }}
              className="group relative overflow-hidden bg-black"
            >
              <img
                src={place.image}
                alt={place.title}
                className="w-full h-56 md:h-64 object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-colors" />
              <div className="absolute inset-0 flex items-end">
                <div className="p-6 w-full flex items-center justify-start">
                  <p className="text-white font-serif text-xl transition-all duration-300 group-hover:text-2xl">{place.title}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="px-8 py-3 border border-black text-black uppercase tracking-[0.3em] text-[10px]">
            View Signature Destinations
          </button>
        </div>
      </div>
    </section>
  );
}